import {
  SupplierRelationshipList_suppliersResponseType,
  BusinessGetResponseType,
  OrderGetResponseType,
} from "@sellar-io/api-v2/types";
import { sanitizeEmailArray } from "@sellar-io/common";
import {
  ORDER_FULFILLMENT_TYPES,
  ORDER_PAYMENT_TYPES,
} from "../../../../constants/sellarConstants.shared";

export const showOrderInvoice = (order: OrderGetResponseType) => {
  if (order.invoiceIssuedAt) return true;
  if (order.confirmedAt) {
    if (
      (order.Supplier.invoiceCreationStage === "confirmed" &&
        order.paymentDue) ||
      order.paymentType === "checkout"
    )
      return true;
  }

  if (order.paymentDue) {
    if (
      order.dispatchedAt &&
      order.Supplier.invoiceCreationStage === "dispatched"
    )
      return true;
    if (
      order.deliveredAt &&
      order.Supplier.invoiceCreationStage === "delivered"
    )
      return true;
  }

  return false;
};

export const showOrderDelivered = (order: OrderGetResponseType) => {
  if (order.confirmedAt) {
    if (
      !order.dispatchedAt &&
      !order.deliveredAt &&
      order.fulfillmentType !== ORDER_FULFILLMENT_TYPES.COLLECTION.value &&
      order.fulfillmentType !== ORDER_FULFILLMENT_TYPES.DISTRIBUTION.value
    ) {
      return true;
    }
  }

  return false;
};

export const showOrderCancel = ({
  order,
  business,
  canUseSellarCreditFeatures,
}: {
  order: OrderGetResponseType;
  business: BusinessGetResponseType;
  canUseSellarCreditFeatures: boolean;
}) => {
  if (business.Retailer && order.confirmedAt) {
    return false;
  }

  const isOrderStateCancellable =
    !order.deliveredAt &&
    !order.cancelledAt &&
    !order.dispatchedAt &&
    !order.SupplierPalletShipment?.dispatchedAt;

  if (
    canUseSellarCreditFeatures &&
    order.paymentType === "sellarCredit" &&
    isOrderStateCancellable &&
    business.Retailer
  ) {
    return true;
  }

  const isAcceptablePaidPaymentType =
    order.paidAt &&
    [
      ORDER_PAYMENT_TYPES.MANUAL.value,
      ORDER_PAYMENT_TYPES.CHECKOUT.value,
      ORDER_PAYMENT_TYPES.STRIPE.value,
      ORDER_PAYMENT_TYPES.CARD_PAYMENT.value,
    ].includes(order.paymentType ?? "");
  const orderIsNotPaid = !order.paidAt;
  return !!(
    isOrderStateCancellable &&
    (orderIsNotPaid || isAcceptablePaidPaymentType)
  );
};

export const showIssueCreditNote = ({
  order,
  canUseSellarCreditFeatures,
}: {
  order: OrderGetResponseType;
  canUseSellarCreditFeatures: boolean;
}) => {
  const isSellarCreditOrder = order.paymentType === "sellarCredit";
  const hasBeenDispatched = Boolean(order.dispatchedAt);

  return isSellarCreditOrder && hasBeenDispatched && canUseSellarCreditFeatures;
};

export const showIssueSellarImportCreditNote = ({
  order,
}: {
  order: OrderGetResponseType;
}) => {
  const isSellarImportOrder = order.paymentType === "cardPaymentWithDeposit";
  const hasBeenDispatched = Boolean(order.dispatchedAt);

  return isSellarImportOrder && hasBeenDispatched;
};

export const getBuyerEmails = (
  order: OrderGetResponseType,
  connection?: Pick<
    SupplierRelationshipList_suppliersResponseType[number],
    "buyerInvoiceEmails"
  >,
) => {
  if (order.retailerInvoiceEmails?.length) {
    return order.retailerInvoiceEmails;
  }

  if (connection?.buyerInvoiceEmails?.length) {
    return connection.buyerInvoiceEmails;
  }

  const sanitizedBusinessInvoiceEmails = sanitizeEmailArray(
    order.Retailer.Business.invoiceEmails,
  );
  const buyerEmails =
    sanitizedBusinessInvoiceEmails.length > 0
      ? sanitizedBusinessInvoiceEmails
      : [order.Retailer.Business.email];

  return buyerEmails;
};

export const showIssueRefund = (order: OrderGetResponseType) => {
  if (
    order.paymentType === "checkout" &&
    order.paymentStatus === "paid" &&
    order.confirmedAt
  ) {
    return true;
  }

  return false;
};
